import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12.794 4.035A.79.79 0 0 0 12 3.25a.79.79 0 0 0-.794.785v4.184a.79.79 0 0 0 .794.784.79.79 0 0 0 .794-.784z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M18.364 5.572a.8.8 0 0 0-1.123 0 .78.78 0 0 0 0 1.11 7.3 7.3 0 0 1 2.028 3.748 7.24 7.24 0 0 1-.421 4.23 7.34 7.34 0 0 1-2.73 3.287A7.5 7.5 0 0 1 12 19.181a7.5 7.5 0 0 1-4.118-1.234 7.34 7.34 0 0 1-2.73-3.286 7.24 7.24 0 0 1-.421-4.23 7.3 7.3 0 0 1 2.028-3.75.78.78 0 0 0 0-1.11.8.8 0 0 0-1.123 0 8.86 8.86 0 0 0-2.463 4.553 8.8 8.8 0 0 0 .512 5.137A8.9 8.9 0 0 0 7 19.251a9.1 9.1 0 0 0 5 1.499c1.78 0 3.52-.521 5-1.498a8.9 8.9 0 0 0 3.315-3.99 8.8 8.8 0 0 0 .512-5.138 8.86 8.86 0 0 0-2.463-4.552"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }